import React, { useState, useEffect } from 'react';
import { Redirect, Route, Switch } from 'react-router-dom';
import { Header, Footer, ScrollTop } from '@graffer-inc/graffer-ui';
import Home from '../pages/home';
import EntryNew from '../pages/entry/new';
import EntryComplete from '../pages/entry/complete';
import EntryInvoice from '../pages/entry/invoice-download';
import EntryConfirm from '../pages/entry/confirm';
import EntryDetail from '../pages/entry/detail';
import Loading from '../molecules/loading';
import CompanySetting from '../pages/setting/company';
import StampSubmitterSetting from '../pages/setting/stamp-submitter';
import WelcomeCompanySetting from '../pages/welcome/company-setting';
import WelcomeStampSubmitterSetting from '../pages/welcome/stamp-submitter-setting';
import Http from '../../http';
import { connect } from 'react-redux';
import { setLoginAccount, setStampSubmitter, setPriceTable, setEntries } from '../../redux/modules/user';
import Transition from "../../utils/transition";
import * as jssha from "js-sha256";
import * as moment from "moment";
import * as store from 'store';
import {
  faHome,
  faBuilding,
  faSignOutAlt,
  faUser,
} from '@fortawesome/free-solid-svg-icons';
import Const from '../../constants';


const Main = ({ loginAccount, setLoginAccount, stampSubmitter, setStampSubmitter, setPriceTable, setEntries }) => {

  const [isRequesting, setIsRequesting] = useState(false);

  useEffect(() => {
    setIsRequesting(true);
    const fetchPriceTable = async () => {
      await Http.fetchPriceTable(res => {
        setPriceTable(res.data.priceTable);
      });
    };
    const fetchLoginAccount = async () => {
      await Http.fetchLoginAccount(async res => {
        const fetchedLoginAccount = res.data.isAuthed ? res.data : null;
        setLoginAccount(fetchedLoginAccount);
        if (!fetchedLoginAccount) {
          store.set(Const.STORAGE.ACCESS_PATH, window.location.pathname + window.location.search);
          await Http.logout();
          Transition.goToLogin();
        }
      },
        () => {
          store.set(Const.STORAGE.ACCESS_PATH, window.location.pathname + window.location.search);
          Transition.goToLogin();
        });
    }
    fetchPriceTable();
    fetchLoginAccount();
    setIsRequesting(false);
  }, [setLoginAccount, setPriceTable]);

  useEffect(() => {
    const fetchStampSubmitter = async () => {
      await Http.fetchStampSubmitter(res => {
        setStampSubmitter(res.data.stampSubmitter);
        // 遷移先判定
        if (!loginAccount.company || !loginAccount.company.corporateId) {
          Transition.goTo('/welcome/company-setting');
        } else if (!res.data.stampSubmitter) {
          Transition.goTo('/welcome/stamp-submitter-setting');
        } else {
          if (window.location.pathname.includes('welcome')) {
            Transition.goTo('/entries/new');
          }
        }
      });
    };
    const fetchEntries = async () => await Http.fetchEntries(res => setEntries(res.data.entries));
    if (!loginAccount) {
      return;
    }
    setIsRequesting(true);
    window.dataLayer.push({
      user_id: jssha.sha256(loginAccount.user.userId),
      regist_month: moment(loginAccount.user.createdAt).format('YYYY年MM月'),
    });
    // NOTE: help scountでの問い合わせの設定
    const { id, lastName, firstName, email } = loginAccount.user;
    window.Beacon('identify', {
      signature: id
    });
    window.Beacon('prefill', {
      name: `${lastName || ''} ${firstName || ''}`,
      email
    });
    const accessPath = store.get(Const.STORAGE.ACCESS_PATH);
    if (accessPath) {
      store.remove(Const.STORAGE.ACCESS_PATH);
      Transition.goTo(accessPath);
    }
    fetchStampSubmitter();
    fetchEntries();
    setIsRequesting(false);
  }, [loginAccount, setEntries, setStampSubmitter]);

  return loginAccount && (
    <div>
      <Header
        fixed
        serviceName="電子証明書取得サポート"
        onClickLogo={() => Transition.goTo('/')}
        menuLabel={
          loginAccount && loginAccount.user.firstName && loginAccount.user.lastName
            ? `${loginAccount.user.lastName} ${loginAccount.user.firstName}`
            : 'メニュー'
        }
        menuItems={
          loginAccount
            ? [
              { name: 'ホーム', onClick: () => Transition.goTo('/home'), icon: faHome },
              { name: '自社設定の変更', onClick: () => Transition.goTo('/settings/company'), icon: faBuilding },
              { name: '印鑑提出者設定の変更', onClick: () => Transition.goTo('/settings/stamp-submitter'), icon: faUser },
              {
                name: 'ログアウト', onClick: async () => await Http.logout(Transition.goToLogin, Transition.goToLogin), icon: faSignOutAlt
              }
            ]
            : []
        }
        menuDividerPositions={loginAccount ? [3] : []}
      />
      <div className="section" style={{ marginTop: '52px' }}>
        {
          isRequesting ? (<Loading />) : (
            <ScrollTop>
              <Switch>
                <Route exact path="/home" component={Home} />
                <Route exact path="/entries/new" component={EntryNew} />
                <Route exact path="/entries/confirm" component={EntryConfirm} />
                <Route exact path="/entries/:entryId" component={EntryDetail} />
                <Route exact path="/entries/:entryId/complete" component={EntryComplete} />
                <Route exact path="/entries/:entryId/invoice" component={EntryInvoice} />
                <Route exact path="/settings/company" component={CompanySetting} />
                <Route exact path="/settings/stamp-submitter" component={StampSubmitterSetting} />
                <Route exact path="/welcome/company-setting" component={WelcomeCompanySetting} />
                <Route exact path="/welcome/stamp-submitter-setting" component={WelcomeStampSubmitterSetting} />
                <Redirect from="*" to="/home" />
              </Switch>
            </ScrollTop>
          )
        }
      </div>
      <Footer
        linkInfos={[
          { name: '運営会社', onClick: () => Transition.newTab('https://graffer.jp') },
          { name: '利用規約', onClick: () => Transition.newTab('https://graffer.jp/legal/terms-e-cert') },
          {
            name: 'Grafferアカウント利用規約',
            onClick: () => Transition.newTab('https://graffer.jp/legal/account-policy')
          },
          {
            name: '特定商取引法に基づく表記',
            onClick: () => Transition.newTab('https://graffer.jp/legal/scta-e-cert')
          },
          {
            name: 'プライバシーポリシー及び個人情報の取り扱いについて',
            onClick: () => Transition.newTab('https://graffer.jp/legal/privacy-policy')
          },
          { name: 'お問い合わせ', onClick: () => Transition.newTab('https://form.run/@graffer-el-cert') }
        ]}
      />
    </div>
  );
}

export default connect(
  store => ({ loginAccount: store.user.loginAccount, stampSubmitter: store.user.stampSubmitter }),
  { setLoginAccount, setStampSubmitter, setPriceTable, setEntries }
)(Main);